/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVR4nOWUS0rDYBDHsxEvoCt13RO4VhEh0Mwji3SmuM8NfJxA6w28QkvBK1SxV9ALqCsV326klYmhVpLU5tGF+MFAvnyZ/29eXxznXywiWUGWLrA+mSHLCWJQq0wcSO+QdfjT5N7OSgOQpZsUj420UxoAUUkyACyPMwUA6UNpAFpDM0sk7fIADGrW0GT0cuv728tOZWNK2rGaR0bSrkx8psuiBJI9YD0Flmsg/YjMnu0d6W6hTFzXnUeWIyR5zx7R0SS9IWvLfKYTD4JFYO3/JozJS3fuec2FieJhGM4hSS+3OMfZsPYnZhKVpaA4ft+Ng1Rxa9Y0NccpelKvB0tp0e+Xjp5H/6idBABYz8bSvCwQ+cWYfy8JILmJP3z2SDbzAjxuriHLS7y/SgFE8zwElmPExkZeAJGsR75f+9eUHmjLDjy/sQq+biHrIAdgYD7maxpAepg5qn9ufQIhDNI92HGj2wAAAABJRU5ErkJggg==)
 */
export const UserIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M12 10a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM11.53 11A9.53 9.53 0 0 0 2 20.53c0 .81.66 1.47 1.47 1.47h.22c.24 0 .44-.17.5-.4.29-1.12.84-2.17 1.32-2.91.14-.21.43-.1.4.15l-.26 2.61c-.02.3.2.55.5.55h11.7a.5.5 0 0 0 .5-.55l-.27-2.6c-.02-.26.27-.37.41-.16.48.74 1.03 1.8 1.32 2.9.06.24.26.41.5.41h.22c.81 0 1.47-.66 1.47-1.47A9.53 9.53 0 0 0 12.47 11h-.94Z"
        className={colorClass}
      />
    </svg>
  );
};
